// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AreaResponse

import { DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type AreaApiResponse = {
	id: string;
	parentId: string;
	name: string;
	color: string;
	capacity: number;
	dailyBookingLimit: number;
	priorityOrder: number;
	followAddress: boolean;
	address: string | null;
	addressExtra: string | null;
	postBookingInfo: string;
	googleAuthForBookingsId: number | null;
	archivedAt: string | null;
};

export type Area = {
	id: string;
	parentId: string;
	name: string;
	color: string;
	capacity: number;
	dailyBookingLimit: number;
	priorityOrder: number;
	followAddress: boolean;
	address: string | null;
	addressExtra: string | null;
	postBookingInfo: string;
	googleAuthForBookingsId: number | null;
	archivedAt: DateTime | null;
};

export function hydrateArea(data: AreaApiResponse): Area {
	return {
		...data,
		archivedAt: DateTimefromISO(data.archivedAt),
	};
}